import { mapState } from 'vuex'

import Lottie from 'vue-lottie-web'
import lottieDataCenter from './data/larkspur_Niz_final.json'
import lottieDataLeft from './data/proplus_L.json'
import lottieDataRight from './data/proplus_R.json'
import PaymentModal from './PaymentModal'

import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';

import quizarticle from '@/components/quizarticle/index.vue'


export default {
  name: 'wai_employers',
  props: {},

  components: {
    quizarticle,
    Lottie,
    PaymentModal,
    RequestButton,
    RequestButtonFxd
  },

  data: function() {
    return {
      loading: false,
      show: false,
      type: 0,
      price: 0,
      hiddenarticleshowed: false,
      lottieDataCenter,
      timeend: null,
      lottieDataLeft,
      lottieDataRight,
      lottieInstance: '',
      fadeClass: 'fade-out',

      isRDVisible: true,
      workwidth: 0,
      members: [
        {
          img: 'imt1.jpg',
          text1: 'Sergei',
          text2: 'Co-Founder & CEO',
          link: 'https://www.linkedin.com/in/sergei-polevikov-7656963b/',
        },

        {
          img: 'imt2.jpg',
          text1: 'Daniel',
          text2: 'Co-founder & Machine Learning Lead',
          link: 'https://www.linkedin.com/in/daniel-satchkov-3986421/',
        },

        {
          img: 'imt5.jpg',
          text1: 'Carlson',
          text2: 'Lead Medical Researcher',
          link: 'https://www.linkedin.com/in/carlson-aruldas-3751461b6/',
        },

        {
          img: 'imt4.jpg',
          text1: 'Val',
          text2: 'Back End Architect',
          link: 'https://www.linkedin.com/in/valentin-kolesov-9a1b931/',
        },
        {
          img: 'imt3.jpg',
          text1: 'Max',
          text2: 'Front End Architect',
          link: 'https://www.linkedin.com/in/max-grishkov-20a52aa8/',
        },
      ],

      testimonials: [
        // {
        //   text:
        //     'RiXtrema is by far the best product our company has utilized for both prospecting and generating proposals for ERISA prospects. When using RiXtrema to present to prospects, our closing rate has increased drastically. It makes it very easy for any individual to understand and digest. On top of the great product, the support and customer service have been outstanding!',
        //   img: 'ngavitt.jpg',
        //   name: 'Nathaniel Gavitt',
        //   rg: 'Investment Adviser of the Everest Consultants, LLC',
        // },
        {
          text:
            'RiXtrema is by far the best product our company has utilized for both prospecting and generating proposals for ERISA prospects. When using RixTrema to present to prospects, our closing rate has increased drastically.   It makes it very easy for any individual to understand and digest. On top of the great product, the support and customer service have been outstanding!',
          img: 'apas.jpg',
          name: 'Alexander Pasquale',
          rg: 'President of the Everest Consultants, LLC',
        },

        {
          text:
            'I wanted to give a recommendation to the group at Rixtrema! We’ve worked together adding a few personalized features to the web site and the service has been outstanding. The web site has allowed me to double my prospecting efforts.',
          img: 'greghicks.jpg',
          name: 'Greg Hicks',
          rg: 'CRPC® Vice President – Investments',
        },

        {
          text:
            'Our firm can not only provide excellent plan governance but the cost sayings can be truly eye opening. Builds credibility with your strategic partners and enhances referrals. Also the support has been amazing when I have questions, response is outstanding!',
          img: 'valerib.jpg',
          name: 'Valeri Bishop',
          rg: 'AIF®',
        },
        {
          text:
            'An excellent combination of dynamically-presented plan data with a strong built in marketing system, wrapped in great concierge-level training & service to make it impactful for Advisors.',
          img: 'briant.png',
          name: 'Brian Thompson',
          rg: 'CPFA | Retirement Plan Advisor & Wealth Manager',
        },
        {
          text:
            'Larkspur Executive has really helped streamline our marketing and target our audience for far more efficiency. The ability to see who is opening mail and even enable them to respond with a click so we can act quickly to schedule meetings is smart and valuable. I don’t have to make random calls because this program allows our firm to reach out to those only who respond to our communications, making our conversations focused and our time productive. The ease in which we can use this software and, mostly, the hands-on support is fantastic. Very pleased with this investment and it has already paid for itself.',
          img: 'terri.png',
          name: 'Terri',
          rg: 'Advisor: President of the Retirement Consulting Firm',
        },
        /* ,
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                },
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                },
                {
                    text : '',
                    img : '',
                    name : '',
                    rg : ''
                }*/
      ],

      offers: {
        products: {
          basic: {
            name: 'Pro',
            price: '$3495',
            //special: '$4,995',

            best: true,
            pricenum: 4995,
            type: 1,
            period: 12,
          },

          platinum: {
            name: 'Platinum Plan Accelerator',
            price: '$12,995',

            best: false,
            pricenum: 12995,
            type: 2,
            period: 12,
          },
        },

        features: {
          ch2k: {
            text: 'Consultants create and launch your online marketing for 2021 ($4,995 Value)',
            icon: '<i class="fas fa-check"></i>',

            basic: true,
          },
          plans: {
            text: 'Marketing campaign targeting 500 plan sponsors every month starting in mid-January 2021 ($6,995 Value) and will run throughout 2021 (Up to 6000 plan sponsors in 2021)',
            icon: '<i class="fas fa-globe-americas"></i>',
            basic: true,
          },

          mb: {
            text: 'Consultants create landing pages to attract plan sponsors ($600 Value)',
            icon: '<i class="fas fa-dollar-sign"></i>',
            basic: true,
          },

          sc: {
            text: 'Consultants create your special lead magnets using marketing quizzes ($1,200 Value)',
            icon: '<i class="fas fa-route"></i>',
            basic: true,
          },

          fs: {
            text: '401kFiduciaryOptimizer 3.0 – the software that will help you win audited plans ($4,200 Value)',
            icon: '<i class="fas fa-check"></i>',

            basic: true,
          },

          // descapro: {
          //   text:
          //     'Expert designed email campaign available to you on day 1 of subscription',
          //   value: '$2300',
          //   icon: '<i class="fas fa-tasks"></i>',

          //   basic: true,
          // },

          crmpro: {
            text:
              '1.2+ million plan executives with contact data at your fingertips that will power email campaigns',
            // value: '$2300',
            icon: '<i class="fas fa-tasks"></i>',
            b1: 1,
            basic: true,
          },

          vlds: {
            text:
              'Database with 850,000+ plans',
            // value: '$300',
            icon: '<i class="fas fa-tasks"></i>',
            b1: 2,
            basic: true,
          },

          mq: {
            text: 'FundScreener to Improve Plan Menus',
            // value: '$1200',
            icon: '<i class="fas fa-tasks"></i>',
            b1: 3,
            basic: true,
          },

          // mq1: {
          //   text: '1.2+ million plan executives with contact data at your fingertips',
          //   // value: '$1200',
          //   icon: '<i class="fas fa-tasks"></i>',
          //   b1: 4,
          //   basic: true,
          // },

          mq2: {
            text: 'Mobile app to immediately follow up with inbound leads from home',
            // value: '$1200',
            icon: '<i class="fas fa-tasks"></i>',
            b1: 4,
            basic: true,
          },

          mq3: {
            text: 'New Bonus! Our team will create 5 videos for you from text or audio clips',
            // value: '$1200',
            icon: '<i class="fas fa-tasks"></i>',
            b1: 5,
            basic: true,
          },

          samept: {
            text: 'Everything in Elite Plan Accelerator +',
            icon: '<i class="fas fa-caret-left"></i>',

            platinum: true,
          },
          campaignspt: {
            text: 'Run Up to 3000 (!) Simultaneous Campaigns',
            icon: '<i class="fas fa-route"></i>',
            platinum: true,
          },

          chept: {
            text: 'Monthly “Mastermind” Sessions with Top Plan Advisors',
            icon: '<i class="fas fa-check"></i>',

            platinum: true,
          },

          chept2: {
            text: 'Monthly “Mastermind” Sessions with Top Marketing Experts',
            icon: '<i class="fas fa-check"></i>',

            platinum: true,
          },

          /*exclusivity : {
                        text : "Exclusivity on 500 Plans! You can choose to protect up to 500 plans, nobody emails them while your campaign is running",
                        icon : '<i class="fas fa-lock"></i>',
                        platinum : true
                    },*/
        },
      },
    }
  },

  mounted: function() {
    
    this.changeFadeClass();
    window.addEventListener('scroll', this.changeFadeClass);

    this.setworkwidth()

    var to = this.$route.query.to

    this.scrollto(to)

    this.inittimeinterval()
  },

  created: () => {},

  watch: {
    //$route: 'getdata'
  },

  beforeRouteEnter(to, from, next) {
    next()
  },

  beforeRouteUpdate(to, from, next) {
    next()
  },

  computed: mapState({
    auth: (state) => state.auth,
    spoffertext: function() {
      if (this.$route.query.dt == '20221111000000') {
        return 'Special Offer for NAPA Readers'
      }

      return 'Special Offer'
    },
  }),

  methods: {
    changeFadeClass(){

      if (document.documentElement.scrollTop > 400){
  
        this.fadeClass = 'fade-in';
  
      } else {
  
        this.fadeClass = 'fade-out';
      }
  
    },

    showModal(type, price) {
      this.show = true
      this.type = type
      this.price = price
    },
    closeModal() {
      this.show = false
    },
    scrolltooffer: function() {
      this.scrollto('offerl', 4)
    },
    scrollto: function(to, tm) {
      if (to) {
        let elmnt = document.getElementById(to)

        setTimeout(function() {
          elmnt.scrollIntoView(true)
          window.scrollBy(0, -90)
        }, tm || 500)
      }
    },
    inittimeinterval: function() {
      var EXPIRED_DATE = '20221012000000'

      var dt = this.$route.query.dt

      if (dt) EXPIRED_DATE = dt

      this.timeend = new Date(
        EXPIRED_DATE.slice(0, 4),
        EXPIRED_DATE.slice(4, 6),
        EXPIRED_DATE.slice(6, 8),
        EXPIRED_DATE.slice(8, 10),
        EXPIRED_DATE.slice(10, 12)
      )

      setInterval(this.timeinterval, 1000)
    },
    timeinterval: function() {
      var today = new Date()
      today = Math.floor((this.timeend - today) / 1000)

      var tsec = today % 60
      today = Math.floor(today / 60)
      if (tsec < 0) tsec = '00'
      else if (tsec < 10) tsec = '0' + tsec
      var tmin = today % 60
      today = Math.floor(today / 60)
      if (tmin < 0) tmin = '00'
      else if (tmin < 10) tmin = '0' + tmin
      var thour = today % 24
      today = Math.floor(today / 24)
      if (thour < 0) thour = '00'
      if (today < 0) today = '00'

      this.$refs.days.innerText = today
      this.$refs.seconds.innerText = tsec
      this.$refs.minutes.innerText = tmin
      this.$refs.hours.innerText = thour

      this.$refs.days1.innerText = today
      this.$refs.seconds1.innerText = tsec
      this.$refs.minutes1.innerText = tmin
      this.$refs.hours1.innerText = thour

      this.$refs.days2.innerText = today
      this.$refs.seconds2.innerText = tsec
      this.$refs.minutes2.innerText = tmin
      this.$refs.hours2.innerText = thour
    },
    hiddenarticleshow: function() {
      this.hiddenarticleshowed = !this.hiddenarticleshowed
    },
    setworkwidth: function() {
      if (this.$refs.videowork) {
        this.workwidth = this.$refs.videowork.clientWidth
      }
    },

    getLottieInstance(lottieInstance) {
      this.lottieInstance = lottieInstance
    },
    lottiePlay() {
      this.lottieInstance && this.lottieInstance.play()
    },
    lottieRePlay() {
      this.lottieInstance && this.lottieInstance.stop()
      setTimeout(() => {
        this.lottieInstance.play()
      })
    },
    lottiePause() {
      this.lottieInstance && this.lottieInstance.pause()
    },
    lottieStop() {
      this.lottieInstance && this.lottieInstance.stop()
    },

    requestDemoVisibilityChanged(isRDVisible) {
      this.isRDVisible = isRDVisible
    },
  },


  beforeDestroy(){
    window.removeEventListener('scroll', this.changeFadeClass);

  }
}
